import { render, staticRenderFns } from "./AxArtboardUploadsItem.vue?vue&type=template&id=00ffabf7&scoped=true&"
import script from "./AxArtboardUploadsItem.vue?vue&type=script&lang=ts&"
export * from "./AxArtboardUploadsItem.vue?vue&type=script&lang=ts&"
import style0 from "./AxArtboardUploadsItem.vue?vue&type=style&index=0&id=00ffabf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ffabf7",
  null
  
)

export default component.exports